import React from 'react';
import { Center, Flex, Heading, Link as ChakraLink, Stack, Text } from '@chakra-ui/react';
import { ConfigMenuItem } from '../components/ConfigMenuItem';
import { RiShieldCrossLine, RiShieldFlashLine, RiShieldKeyholeLine, RiShieldStarLine } from 'react-icons/ri';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import { Link as RouterLink } from 'react-router-dom';

export const Security = () => {
  return (
    <>
      <Heading as='h2' fontSize="xl">Seguridad</Heading>
      <ChakraLink as={RouterLink} to="../." color="neutral.800" >
        <Flex alignItems="center" marginTop="l">
          <MdKeyboardArrowLeft />
          <Text marginLeft="l">Volver a configuraciones</Text>
        </Flex>
      </ChakraLink>

      <Center marginTop="xxxl">
        <Stack spacing="xl" borderWidth="1px" borderColor="neutral.300" borderRadius="xl" padding="xxxl">
         {/*  <ConfigMenuItem icon={<RiShieldFlashLine />} label="Tengo un problema de seguridad" />
          <ConfigMenuItem icon={<RiShieldStarLine />} label="Métodos de verificación"
            description="Protege tu cuenta" />
          <ConfigMenuItem icon={<RiShieldCrossLine />} label="Dispositivos vinculados"
            description="Controlá los dispositivos en los que se ha iniciado sesión" /> */ }
          <ConfigMenuItem link="change-password" icon={<RiShieldKeyholeLine />} label="Cambiar contraseña"
            description="Puedes modificar tu contraseña una vez por mes" />
        </Stack>
      </Center>
    </>
  );
};
